import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
interface UserProfile {
  name: string
  grade: string
  fullName: string
  gradeSection: string
  schoolName: string
  tutor: string
  email: string
  avatar?: string
}

interface ChatItem {
  id: string
  title: string
  isActive?: boolean
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent  implements OnInit{
  userProfile: UserProfile = {
    name: "Mark",
    grade: "Grade 10",
    fullName: "Mark Taylor",
    gradeSection: "10 class 'A' section",
    schoolName: "Eternal Light Public School",
    tutor: "Lia John",
    email: "Vk@gmail.com",
  }

  savedChats: ChatItem[] = [
    { id: "1", title: "Explain the Industrial Revolution", isActive: false },
    { id: "2", title: "Can you help me understand fr...", isActive: false },
    { id: "3", title: "Social Studies", isActive: true },
  ]

  yesterdayChats: ChatItem[] = [
    { id: "4", title: "Explain the difference between ...", isActive: false },
    { id: "5", title: "What is a programming language?", isActive: false },
  ]

  chatHistory: ChatItem[] = [
    { id: "6", title: "What are the continents of the ...", isActive: false },
    { id: "7", title: "Explain the Industrial Revolution.", isActive: false },
    { id: "8", title: "If a triangle has sides 3 cm, 4 c ...", isActive: false },
  ]

  searchQuery = ""
  user: any;

  constructor( private authService: AuthService) {}

  ngOnInit(): void {
    this.user = this.authService.getUser();
  }

  onNewChat(): void {
    console.log("Starting new chat...")
  }

  onSearchChange(): void {
    console.log("Search query:", this.searchQuery)
  }

  onChatSelect(chat: ChatItem): void {
    // Reset all active states
    this.savedChats.forEach((c) => (c.isActive = false))
    this.yesterdayChats.forEach((c) => (c.isActive = false))
    this.chatHistory.forEach((c) => (c.isActive = false))

    // Set selected chat as active
    chat.isActive = true
    console.log("Selected chat:", chat.title)
  }

  onLogout(): void {
    console.log("Logging out...")
  }

  onEditProfile(): void {
    console.log("Edit profile clicked")
  }
}
